import React from 'react';
import {
    Container,
    Row,
    Col,
    TabsTab,
    TabsList,
    TabsV2,
    TabPanel,
    Callout,
    CalloutTitle,
    CalloutBody,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuList,
    DropdownMenuLink,
} from '@design-system-etat/dsfr-react';
import { useSelector } from 'react-redux';
import Armes from './armes';
import Munitions from './munitions';
import RepriseDeDonneesArme from './armes/components/repriseDeDonnees/index';
import {
    DROITS_RATELIER_AJOUTER_UNE_ARME,
    ROLE_CORRECTION_RATELIER_ARMES,
    ROLE_HERITIER,
    ROLE_TIREUR_SPORTIF,
} from '../../../utils/droitsEtRoles.constant';
import verifierDroits from '../../../components/VerifierDroits/verifierDroits.func';
import Historique from './historique';
import { getPath } from '../../../utils/router';
import RoutesDemandeArmeHeritee from '../armes/demande-arme-heritee/routes';
import RoutesDemandeArmeTrouvee from '../armes/demande-arme-trouvee/routes';
import VerifierDroitsComponent from '../../../components/VerifierDroits/VerifierDroitsComponent';
import RoutesSignalerArmeManquante from '../armes/signaler-arme-manquante/routes';
import FeatureFlippingComponent from '../../../components/FeatureFlipping/FeatureFlippingComponent';
import { FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER } from '../../../components/FeatureFlipping/featureFlipping.func';
import styles from './index.module.scss';

const OngletCustom = (verifDroitTireurSportif) => {
    const onglets = [
        {
            titre: 'Mes armes',
            idAria: 'Mes-armes',
            onglet: <Armes />,
        },
    ];

    if (verifDroitTireurSportif.verifDroit) {
        onglets.push({
            titre: 'Mes munitions',
            idAria: 'Mes-munitions',
            onglet: <Munitions />,
        });
    }

    onglets.push({
        titre: 'Mon historique',
        idAria: 'Mon-historique',
        onglet: <Historique />,
    });

    return (
        <TabsV2>
            <TabsList label="choix du materiel" id="armes">
                {onglets.map((onglet) => {
                    return <TabsTab idTab={onglet.idAria}>{onglet.titre}</TabsTab>;
                })}
            </TabsList>
            {onglets.map((onglet) => {
                return <TabPanel idTab={onglet.idAria}>{onglet.onglet}</TabPanel>;
            })}
        </TabsV2>
    );
};

const Ratelier = () => {
    const { data: dataProfil } = useSelector((state) => state.profil.usager);

    return (
        <Container fluid={false}>
            <Row gutters>
                <Col>
                    <h1>Mon râtelier numérique</h1>
                </Col>
            </Row>
            <Row gutters>
                <Col>
                    <Callout icon="fr-fi-information-line" title="Titre mise en avant" titleAs="h2">
                        <CalloutTitle titleAs="h2" __TYPE="CalloutTitle">
                            Vérifiez les informations liées à vos armes
                        </CalloutTitle>
                        <CalloutBody __TYPE="CalloutBody">
                            <p>
                                Vous trouverez ci-dessous les armes que vous possédez, identifiées
                                par un n° d’encodage. Si les informations sont incorrectes, vous
                                devez utiliser la fonctionnalité «Signaler une erreur» disponible
                                dans la fiche détaillée de l'arme. Si des armes sont absentes du
                                râtelier, utilisez la fonctionnalité «Ajouter une arme».
                            </p>
                            <br />

                            <p>
                                Vous disposez de 6 mois pour corriger les informations présentes sur
                                votre râtelier via les deux fonctionnalités précitées. Passé ce
                                délai, les boutons «Signaler une erreur» et «Ajouter une arme» ne
                                seront plus accessibles.
                            </p>
                        </CalloutBody>
                    </Callout>
                </Col>
            </Row>
            <RepriseDeDonneesArme />
            <div className={styles.containerDropdown}>
                <DropdownMenu id="dropdown-link" label="Ajouter une arme" size="md">
                    <DropdownMenuContent>
                        <DropdownMenuList>
                            {dataProfil &&
                                Object.values(dataProfil)[3] &&
                                Object.values(dataProfil)[3].includes(
                                    ROLE_CORRECTION_RATELIER_ARMES,
                                ) && (
                                    <li>
                                        <>
                                            <VerifierDroitsComponent
                                                droits={DROITS_RATELIER_AJOUTER_UNE_ARME}
                                            >
                                                <DropdownMenuLink
                                                    href={getPath(RoutesSignalerArmeManquante)}
                                                >
                                                    Ajouter une arme
                                                </DropdownMenuLink>
                                            </VerifierDroitsComponent>

                                            {/* lorsque on supprime le feature FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER, on combine le compsant VerifierDroitsComponent avec le précident en ajoutant le role ROLE_HERITIER */}
                                            <FeatureFlippingComponent
                                                featureName={
                                                    FEATURE_AUTORISATION_FONCTIONNALITES_COMPTE_DETENTEUR_HERITIER
                                                }
                                            >
                                                <VerifierDroitsComponent droits={[ROLE_HERITIER]}>
                                                    <DropdownMenuLink
                                                        href={getPath(RoutesSignalerArmeManquante)}
                                                    >
                                                        Ajouter une arme
                                                    </DropdownMenuLink>
                                                </VerifierDroitsComponent>
                                            </FeatureFlippingComponent>
                                        </>
                                    </li>
                                )}
                            <li>
                                <DropdownMenuLink href={getPath(RoutesDemandeArmeHeritee)}>
                                    Ajouter une arme héritée
                                </DropdownMenuLink>
                            </li>
                            <li>
                                <DropdownMenuLink href={getPath(RoutesDemandeArmeTrouvee)}>
                                    Ajouter une arme trouvée
                                </DropdownMenuLink>
                            </li>
                        </DropdownMenuList>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
            <OngletCustom verifDroit={verifierDroits(dataProfil, [ROLE_TIREUR_SPORTIF])} />
        </Container>
    );
};

export default Ratelier;
